import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {ICfgAttribute, ICfgAttributeState} from "./Helper";
import {createAttribute, editAttribute, getCfgAttributes} from "./ActionCreators";

const initialValue: ICfgAttributeState = {
    fetchLoading: false,
    items: [],
    actionLoading: false,
}

const cfgAttributeSlice = createSlice({
    name: SliceNames.CFG_ATTRIBUTE,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getCfgAttributes.pending, (state) => {
                state.fetchLoading = true
            })
            .addCase(
                getCfgAttributes.fulfilled, (state, action: PayloadAction<ICfgAttribute[]>) => {
                    state.items = action.payload
                    state.fetchLoading = false
                })
            .addCase(
                getCfgAttributes.rejected, (state) => {
                    state.items = []
                    state.fetchLoading = false
                })
            .addCase(
                createAttribute.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createAttribute.fulfilled, (state, action: PayloadAction<ICfgAttribute>) => {
                    state.items = [...state.items, action.payload]
                    state.actionLoading = false
                })
            .addCase(
                createAttribute.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                editAttribute.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                editAttribute.fulfilled, (state, action: PayloadAction<ICfgAttribute>) => {
                    const index = state.items.findIndex((attr) => attr.id === action.payload.id);
                    if (index !== -1) {
                        state.items[index] = action.payload;
                    }
                    state.actionLoading = false
                })
            .addCase(
                editAttribute.rejected, (state) => {
                    state.actionLoading = false
                })
    }
})

export default cfgAttributeSlice.reducer

